// Shared props + selection helpers for LeftSection and every panel under panels/.
// Moved verbatim from LeftSection.vue. Do NOT rename (the areAllSelectedObjetcs* typo is intentional).
import {
  findObjectById,
  findParentGroup,
  getPropertyApplyTargets,
} from '@/components/Canvas/utils/groupHelpers';

export default {
  props: {
    product:             Object,
    activePage:          Number,
    activeObject:        Object,
    contentList:         { Object, Array },
    bankType:            String,
    selectedObjectsList: { // for multiple objects
      type:    Array,
      default: () => [],
    },
  },
  computed: {
    activeObjectForLeftPanel() {
      // Prefer the activeObject active layer (including a drilled-in group child).
      // Using selectedObjectsList first returned a sibling / stale clone and made
      // Effects show "None" while the canvas still rendered the real effect.
      if (this.activeObject && this.activeObject.type !== 'group') {
        return findObjectById(this.contentList, this.activeObject.Id) || this.activeObject;
      }

      const list = this.getSelectedObjectsList;
      if (list && list.length) {
        const withEffect = list.find(obj => obj
            && obj.effect
            && obj.effect !== 'none'
            && obj.effect !== '');
        const pick       = withEffect || list[0];
        if (pick && pick.Id) {
          return findObjectById(this.contentList, pick.Id) || pick;
        }
      }

      if (this.activeObject && this.activeObject.type === 'group') {
        const children      = this.activeObject.children || [];
        const withEffect    = children.find(obj => obj
            && obj.effect
            && obj.effect !== 'none'
            && obj.effect !== '');
        const fallbackChild = withEffect || children[0];
        if (fallbackChild && fallbackChild.Id) {
          return findObjectById(this.contentList, fallbackChild.Id) || fallbackChild;
        }
      }
      return this.activeObject;
    },
    getSelectedObjectsList() {
      const fromTargets = getPropertyApplyTargets(this.contentList, this.selectedObjectsList, this.activeObject);
      if (fromTargets.length > 1) {
        return fromTargets;
      }
      if (this.activeObject && this.activeObject.type !== 'group' && findParentGroup(this.contentList, this.activeObject.Id)) {
        const activeObject = findObjectById(this.contentList, this.activeObject.Id) || this.activeObject;
        return activeObject ? [activeObject] : [];
      }
      return fromTargets;
    },
    isMultiPropertySelection() {
      const list = this.getSelectedObjectsList;
      return !!(list && list.length > 1);
    },
    getObjectType() {
      if (!this.activeObjectForLeftPanel) { return null; }
      if (this.activeObjectForLeftPanel.type == 'text') {
        return this.activeObjectForLeftPanel.type;
      }
      if (this.activeObjectForLeftPanel.type == 'image') {
        return this.activeObjectForLeftPanel.ImageType;
      }
      if (this.activeObjectForLeftPanel.type == 'shape') {
        return this.activeObjectForLeftPanel.type;
      }
    },
    areAllSelectedObjetcsText() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && object.type === 'text');
    },
    areAllSelectedObjetcsImage() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && object.type === 'image' && object.ImageType === 'Image');
    },
    areAllSelectedObjetcsFDIC() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && object.type === 'image' && (object.ImageType === 'FDICText' || object.ImageType === 'FDICTextWhite'));
    },
    areAllSelectedObjetcsHousing() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && object.type === 'image' && (object.ImageType === 'FDICLogo' || object.ImageType === 'FDICLogoWhite'));
    },
    areAllSelectedObjectsHousingAndFDIC() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && object.type === 'image'
          && [
            'FDICText',
            'FDICTextWhite',
            'FDICLogo',
            'FDICLogoWhite',
          ].includes(object.ImageType));
    },
    areAllSelectedObjetcsWhiteBoxLogo() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && object.type === 'image' && object.ImageType === 'WhiteboxLogo');
    },
    areAllSelectedObjetcsShape() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && (object.type === 'shape' || object.ImageType === 'SVGImage'));
    },
    areAllSelectedObjetcsTable() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && (object.type === 'table'));
    },
    areAllSelectedObjetcsVideo() {
      const list = this.getSelectedObjectsList;
      return list.length > 0 && list.every(object => object && object.type === 'video');
    },
    areAllSelectedObjetcsMultipleTypes() {
      const list      = this.getSelectedObjectsList;
      const allTables = list.length > 0 && list.every(
          object => object.type === 'table',
      );

      const types = new Set(
          list.map((object) => {
            if (object.type === 'shape' || (object.type === 'image' && object.ImageType === 'SVGImage')) {
              return 'svg';
            }
            if (object.type === 'image' && object.ImageType) {
              return `image-${object.ImageType}`;
            }
            return object.type;
          }),
      );
      return allTables || list.length > 0 && types.size > 1;
    },
  },
};
